var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"organization-media-links flex align-center gap10 wrap"},_vm._l((_vm.mediaLinks),function(link){return _c('li',{key:link.id},[_c('a',{staticClass:"hover-pop",attrs:{"href":link.src,"target":"_blank"}},[_c('div',{staticClass:"img svg-parrent",domProps:{"innerHTML":_vm._s(_vm.mediaSvgs[link.type])}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }